import React from "react";

let Kartice = () => {
  return (
    <>
      <div className="flex flex-wrap gap-0.5 items-center justify-center">
        <img
          src={`${process.env.PUBLIC_URL}/img/s6.png`}
          alt="Slika 1"
          className="w-12 sm:w-16 h-auto"
        />
        <img
          src={`${process.env.PUBLIC_URL}/img/s4.png`}
          alt="Slika 2"
          className="w-12 sm:w-16 h-auto"
        />
        <img
          src={`${process.env.PUBLIC_URL}/img/s3.png`}
          alt="Slika 3"
          className="w-16 sm:w-20 h-auto"
        />
        <img
          src={`${process.env.PUBLIC_URL}/img/visa.png`}
          alt="Slika 4"
          className="w-16 sm:w-20 h-auto"
        />
        <img
          src={`${process.env.PUBLIC_URL}/img/s1.png`}
          alt="Slika 5"
          className="w-10 sm:w-14 h-auto"
        />
        <a
          href="https://www.bancaintesa.rs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/s2.png`}
            alt="Slika 6"
            className="w-36 sm:w-48 h-auto"
          />
        </a>
        <a
          href="https://www.mastercard.rs/sr-rs/korisnici/pronadite-karticu.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/s5.png`}
            alt="Slika 7"
            className="w-32 sm:w-44 h-auto"
          />
        </a>
        <a
          href="https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/s8.jpg`}
            alt="Slika 8"
            className="w-8 sm:w-10 h-auto"
          />
        </a>
      </div>
    </>
  );
};

export default Kartice;
